import { render } from "./search.vue?vue&type=template&id=2e082897&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=2e082897&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/open-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e082897"]])

export default __exports__